export enum TIPO_TAREA { AUDITORIA = "auditoria", TAREA = "tarea" }